import React, {
  useCallback,
  useContext,
  useMemo,
  useEffect,
  useState,
} from "react";
import ABMContext from "../context/ABMContext";
import InputText from "./inputs/InputText";
import Fecha from "./inputs/Fecha";
import InputSelect from "./inputs/InputSelect";
import InputCheckbox from "./inputs/InputCheckbox";
import InputRadio from "./inputs/RadioButton";
import InputFile from "./inputs/InputFile";
import AutocompletarABM from "./inputs/AutocompletarABM";
import InputPassword from "./inputs/InputPassword";
import NoteTaker from "../../components/NoteTaker";
import InputTextEscanerColumna from "../../components/InputTextEscaner";
import InputAbmEscaner from "./inputs/InputAbmEscaner";
import InputCam from "./inputs/InputCam";

import Default from "../../Vista/components/columnas/Default";
import FechaSimple from "./inputs/Fecha_simple";
import Toggle from "./inputs/Toggle";
import InputBuscador from "./inputs/InputBuscador/InputBuscador";
import Hidden from "./inputs/Hidden";
import ValorCalculado from "./inputs/ValorCalculado";
import Enlace from "../../Vista/components/columnas/Enlace";

import AutocompletarConFetch from "../../components/AutocompletarConFetch";
import { ReadOnlyTextArea } from "../../components/EditorTextArea";
import EnlaceOpcional from "./columnas/EnlaceOpcional";

import { ListadoProvider } from "../../Listado/Listado";

import ConfigListado from "../../Listado/components/ConfigListado";
import {
  buscarCabeceraPorId,
  getAtributo,
  useEsMobile,
  validarValorCampo,
} from "../../context/FuncionesContext";
import { cumpleDependencias } from "./dependencias";

export const verificarDependencias = (
  valorFormularioNuevo,
  cab,
  data
) => {
  if (!cab?.componente_depende_de_configuracion) return "s";

  const mostrar = cumpleDependencias({
    valorFormulario: valorFormularioNuevo,
    configuraciones: cab.componente_depende_de_configuracion,
    valores: getAtributo(
      "componente_depende_de_valor",
      data,
      cab
    ),
  });

  return mostrar ? "s" : "n";
};

const SwitchABM = (props) => {
  const {
    ABMDispatch,
    valorFormulario,
    opciones,
    dispatch,
    modoAlta,
    configuraciones_cab,
  } = useContext(ABMContext);
  const { cab, data, id_elemento, qsBody, error, setError } = props;
  const esMobile = useEsMobile();
  const gridSpan = esMobile ? cab.grid_span_mobile ?? "1/-1" : cab.grid_span;
  const campokey = cab.campo_alias ? cab.campo_alias : cab.id_a;

  const id_a = cab.id_a;

  const [componenteShow, setComponenteShow] = useState(
    data[cab.id_a + "_componente_show"] ?? "s"
  );

  const setFormularioValor = useCallback(
    (valor, nombreKey) => {
      const tieneNombreKey =
        typeof nombreKey === "string" && nombreKey.trim() !== "";
      const valorOpcion = valor;
      if (["enum", "select", "si_no"].includes(cab.componente)) {
        valor = valor?.value;
      }

      const cabDestino = tieneNombreKey
        ? buscarCabeceraPorId(configuraciones_cab, nombreKey)
        : cab;
      const idError = cabDestino?.id_a ?? nombreKey ?? cab.id_a;
      let validacion = { valido: true, valor };

      if (tieneNombreKey) {
        validacion = cabDestino
          ? validarValorCampo({
              valor,
              cab: cabDestino,
              data,
            })
          : {
              valido: false,
              valor,
              errores: ["No se encontro la configuracion del campo destino."],
              mensaje: "No se encontro la configuracion del campo destino.",
            };
      }

      setError((state) => {
        return {
          ...state,
          [idError]: !validacion.valido,
        };
      });

      if (!validacion.valido) {
        return validacion;
      }
      valor = validacion.valor;

      if (["enum", "select", "si_no"].includes(cab.componente)) {
        if (cab.clave_envio && cab.clave_envio.trim() !== "") {
          ABMDispatch({
            type: "SET_FORMULARIO_VALOR",
            payload: { id_a: cab.clave_envio + "_op", valor: valorOpcion },
          });
        }
        if (tieneNombreKey) {
          ABMDispatch({
            type: "SET_FORMULARIO_VALOR",
            payload: { id_a: nombreKey + "_op", valor: valorOpcion },
          });
        }
      }

      if (cab.clave_envio && cab.clave_envio.trim() !== "") {
        ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: { id_a: cab.clave_envio, valor },
        });
      }
      if (tieneNombreKey) {
        return ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: { id_a: nombreKey, valor },
        });
      }

      return ABMDispatch({
        type: "SET_FORMULARIO_VALOR",
        payload: { id_a, valor },
      });
    },
    [
      ABMDispatch,
      cab,
      configuraciones_cab,
      data,
      id_a,
      setError,
    ],
  );

  // El autocompletar con fetch necesita conservar el objeto completo de la
  // opción, además del value que se utiliza como valor del campo.
  const setOpcionAutocompletarFetch = useCallback(
    (opcion) => {
      ABMDispatch({
        type: "SET_FORMULARIO_VALOR",
        payload: { id_a: `${id_a}_op`, valor: opcion },
      });
    },
    [ABMDispatch, id_a]
  );

  const setErrorConDependencia = useCallback(
    (newValue) => {
      if (cab?.componente_depende_de_configuracion) {
        const show = verificarDependencias(valorFormulario, cab, data);
        if (show === "n") {
          setError((e) => {
            return { ...e, [id_a]: false };
          });
        }
      } else {
        setError(newValue);
      }
    },
    [cab, data, id_a, setError, valorFormulario]
  );

  if (cab.round) {
    if (!isNaN(parseFloat(data[cab.id_a]))) {
      const val = Number.parseFloat(data[cab.id_a]).toFixed(
        parseInt(data[cab.id_a + "_round"] ?? cab.round)
      );
      data[cab.id_a] = val;
    }
  }

  const hijos =
    cab.sc_hijos?.length > 0
      ? cab.sc_hijos
        .sort((a, b) => a.orden - b.orden)
        .map((s, i) => (
          <SwitchABM
            key={s.id_a}
            data={data}
            indiceData={i}
            cab={s}
            padre={cab}
            id_elemento={s.id_a + i}
            error={error}
            setError={setError}
          />
        ))
      : null;

  const seleccionarDatosDeListado = useCallback(
    (rows, opcionesListado) => {
      const clave_envio =
        opcionesListado.clave_envio && opcionesListado.clave_envio.trim() !== ""
          ? opcionesListado.clave_envio
          : undefined;
      if (
        opcionesListado.listado_seleccion_data &&
        opcionesListado.listado_seleccion_data?.trim() !== ""
      ) {
        const extraer_idas = opcionesListado.listado_seleccion_data
          .split("|")
          .map((c) => c.trim());

        const data_extraida = rows
          .map((r) => {
            const rExtraido = extraer_idas.map((e) => r[e]);
            return rExtraido;
          })
          .join("|");

        if (clave_envio) {
          ABMDispatch({
            type: "SET_FORMULARIO_VALOR",
            payload: {
              id_a: clave_envio ?? opcionesListado.id_a,
              valor: [data_extraida],
            },
          });
        }
        ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: {
            id_a: opcionesListado.id_a,
            valor: [data_extraida],
          },
        });
        return;
      }
      if (
        opciones.listado_seleccion_data &&
        opciones.listado_seleccion_data?.trim() !== ""
      ) {
        const extraer_idas = opciones.listado_seleccion_data
          .split("|")
          .map((c) => c.trim());

        const data_extraida = rows
          .map((r) => {
            const rExtraido = extraer_idas.map((e) => r[e]);
            return rExtraido;
          })
          .join("|");

        ABMDispatch({
          type: "SET_FORMULARIO_VALOR",
          payload: { id_a: clave_envio ?? "sideData", valor: [data_extraida] },
        });
      }
    },
    [opciones, ABMDispatch]
  );

  const renderListado = useMemo(() => {
    return (
      <div key={id_elemento} style={{ width: "100%", fontSize: "0.9rem" }}>
        <ListadoProvider
          key={cab.id_a}
          configuracion={cab}
          subirDatosSeleccionados={seleccionarDatosDeListado}
        >
          <ConfigListado />
        </ListadoProvider>
      </div>
    );
  }, [id_elemento, cab, seleccionarDatosDeListado]);

  const Componente = useMemo(
    () =>
      (() => {
        switch (data[`${cab.id_a}_COMPONENTE`] ?? cab.componente) {
          case undefined || "columna_simple":
            return (
              <Default
                key={cab.id_a}
                data={data}
                cab={cab}
                campokey={opciones.modo === 'alta' ? campokey + '_default' : campokey}
                id_elemento={id_elemento}
              />
            );
          case "listado":
            return renderListado;
          case "input_text":
            return (
              <InputText
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                context={ABMContext}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "valor_calculado":
            return (
              <ValorCalculado
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                valorFormulario={valorFormulario}
              />
            );
          case "input_escaner":
            return (
              <InputAbmEscaner
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "input_cam":
          case "inputmobilecam":
            return (
              <InputCam
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "input_textarea":
            return (
              <NoteTaker
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                textarea
                context={ABMContext}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "textarea":
            return (
              <ReadOnlyTextArea
                cab={props.cab}
                data={props.data}
                id_elemento={props.id_elemento}
                valor={valorFormulario[id_a]}
                context={ABMContext}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "input_number_editable":
            return (
              <InputText
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                number
                context={ABMContext}
                error={error}
                setError={setErrorConDependencia}
              />
            );

          case "input_buscador":
            return (
              <InputBuscador
                key={cab.id_a}
                data={data}
                cab={cab}
                hijos={hijos}
                campokey={campokey}
                context={ABMContext}
                id_elemento={id_elemento}
                qsBody={qsBody}
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "password":
            return (
              <InputPassword
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "fecha":
            return (
              <Fecha
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                cab={cab}
                data={data}
              />
            );
          case "fecha_simple":
            return (
              <FechaSimple
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                cab={cab}
                data={data}
              />
            );
          case "input_fecha":
            return (
              <FechaSimple
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                cab={cab}
                data={data}
                modoAlta={modoAlta}
              />
            );
          case "input_file":
            return (
              <InputFile
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "select":
            // if (typeof valorFormulario[id_a] === "undefined") return <></>;
            return (
              <InputSelect
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                valorFormulario={valorFormulario}
                modoAlta={modoAlta}
                id_elemento={id_elemento}
              />
            );
          case "si_no":
            // if (typeof valorFormulario[id_a] === "undefined") return <></>;
            cab.opciones = [
              { value: "s", label: "Si" },
              { value: "n", label: "No" },
            ];
            return (
              <InputSelect
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                modoAlta={modoAlta}
              />
            );
          case "enum":
            // if (typeof valorFormulario[id_a] === "undefined") return <></>;
            return (
              <InputSelect
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                modoAlta={modoAlta}
              />
            );
          case "checkbox":
            return (
              <InputCheckbox
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "radio":
            return (
              <InputRadio
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "autocompletar":
            return (
              <AutocompletarABM
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "autocompletar_fetch":
            return (
              <AutocompletarConFetch
                {...props}
                setValor={setFormularioValor}
                setOpcionSeleccionada={setOpcionAutocompletarFetch}
                valor={valorFormulario[id_a]}
                error={error}
                setError={setErrorConDependencia}
                modoAlta={modoAlta}
              />
            );
          case "toggle":
            return (
              <Toggle
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                id_elemento={id_elemento}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "grupo_columnas":
            return <div
              data-component="grupo_columnas"
              className={`${data[cab.id_a + "_className"] ?? cab.className}`}
            >
              {cab.titulo_cfsf_grupo && cab.titulo_cfsf_grupo.trim() !== "" && (
                <div
                  style={{
                    gridColumn: "1/-1",
                  }}
                  className="titulo_cfsf_grupo"
                >
                  {cab.titulo_cfsf_grupo}
                </div>
              )}
              {hijos}
            </div>
          case "div":
            return (
              <div
                className={`${data[cab.id_a + "_className"] ?? cab.className}`}
              >
                {hijos?.map((hijo) => hijo)}
              </div>
            );
          case "hidden":
            return (
              <Hidden
                {...props}
                setValor={setFormularioValor}
                valor={valorFormulario[id_a]}
                id_elemento={id_elemento}
                error={error}
                setError={setErrorConDependencia}
              />
            );
          case "enlace_opcional":
            return (
              <EnlaceOpcional
                key={cab.id_a}
                data={data}
                cab={cab}
                hijos={hijos}
                campokey={campokey}
                id_elemento={id_elemento}
                qsBody={qsBody}
                valor={data[campokey]}
                updateid={data[cab.update_id_alias]}
              />
            );
          case "enlace":
            return (
              <Enlace
                key={cab.id_a}
                data={data}
                cab={cab}
                hijos={hijos}
                campokey={campokey}
                id_elemento={id_elemento}
              />
            );
          default:
            return <></>;
        }
      })(),
    [
      cab,
      campokey,
      data,
      error,
      hijos,
      id_a,
      id_elemento,
      modoAlta,
      props,
      qsBody,
      renderListado,
      setErrorConDependencia,
      setFormularioValor,
      valorFormulario,
    ]
  );

  useEffect(() => {
    if (!cab?.componente_depende_de_configuracion) return;
    if (cab?.componente_depende_de_configuracion) {
      const show = verificarDependencias(valorFormulario, cab, data);
      setComponenteShow(show);

      const componenteActual =
        data[`${cab.id_a}_COMPONENTE`] ?? cab.componente;

      if (show !== "s" && componenteActual !== "hidden") {
        const idAsALimpiar = [cab.id_a, `${cab.id_a}_op`];
        const claveEnvio = cab.clave_envio?.trim();

        if (claveEnvio) {
          idAsALimpiar.push(claveEnvio, `${claveEnvio}_op`);
        }

        ABMDispatch({
          type: "REMOVE_FORMULARIO_VALORES",
          payload: { id_as: [...new Set(idAsALimpiar)] },
        });
      }

      if (cab.permite_null === "n" && show === "s") {
        dispatch({
          type: "SET_FORMULARIO_OBLIGATORIO",
          payload: { id_a: cab.id_a },
        });
      }
      if (cab.permite_null === "n" && show !== "s") {
        dispatch({
          type: "REMOVE_FORMULARIO_OBLIGATORIO",
          payload: { id_a: cab.id_a },
        });
      }
    }
  }, [ABMDispatch, cab, data, dispatch, valorFormulario]);

  if (
    data[`${cab.id_a}_COMPONENTE`] === "hidden" ||
    cab.componente === "hidden"
  ) {
    return <>{Componente}</>;
  }

  if (componenteShow !== "s") return <></>;
  return (
    <>
      <div
        id={cab.id_a}
        style={{
          gridColumn: gridSpan,
          // height: "100%",
          //  border: error[cab.id_a] ? "2px solid rgba(255,0,0,0.5)" : "",
          borderRadius: "2px",
        }}
        className={"switch_abm_input_base "}
      >
        {Componente}
      </div>
      {/* <Obligatorio {...cab} /> */}
    </>
  );
};

export default React.memo(SwitchABM);
